<!--template html-->
<template>
    <div v-if="displayLoader" class="gt-groupcard-loader" style="z-index: 99999999;">
        <img :src="$getAssetUrlPlugin('siteres/gt-loader.gif')" alt="Loading" />
    </div>
    <div id="gc-setting-modal" class="modal fade gt-md-modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-default-margin modal-dialog-centered">
            <div class="modal-content">
                <div class="gt-md-modal-header">
                    <h2>Group card settings</h2>
                    <div class="gt-modal-close" data-dismiss="modal">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" width="14" height="14">
                                <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 13 1 L 7 7 L 13 13" />
                                <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 1 13 L 7 7 L 1 1" />
                            </svg>
                    </div>
                </div>
                <!-- gt-md-modal-header -->

                <div class="gt-md-modal-content" v-if="settings">
                    <div class="modal-radio mb-5 hidden">
                        <p>Would you like to print & mail the card?</p>
                        <div class="modal-radio-block mt-3" @click="addPrintOption">
                            <label class="radio-label">
                                Yes
                                <input type="radio" name="print" v-model="settings.PrintOption" :value="true" disabled />
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <!-- modal-radio-block -->

                        <div class="modal-radio inline-radio bg-dark-gray" v-if="(settings.Orders.length > 0) && (printOptionValue)">
                            <div v-for="item in settings.Orders">
                                <div class="form-group mt-form  mb-3">
                                    <label for="">Who should we send it to?</label>
                                    <input type="text" class="form-control" v-model="item.CustomerFName" />
                                </div>
                                <div class="form-group mt-form mb-2">
                                    <label for="">Delivery address</label>
                                    <input type="text" class="form-control" v-model="item.CustomerAddress" />
                                </div>
                            </div>
                        </div>
                        <!-- modal-radio -->

                        <div class="modal-radio-block mt-2">
                            <label class="radio-label">
                                No thanks
                                <input type="radio" name="print" v-model="settings.PrintOption" :value="false" />
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <!-- modal-radio-block -->

                    </div>
                    <!-- modal-radio -->

                    <div class="modal-radio mb-0">
                        <p>Can friends sign the group card without chipping in?</p>
                        <div class="modal-radio-block">
                            <label class="radio-label">
                                Yes
                                <input type="radio" name="swc" v-model="settings.SignWithOutContribution" :value="true" />
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <!-- modal-radio-block -->

                        <div class="modal-radio-block">
                            <label class="radio-label">
                                No
                                <input type="radio" name="swc" v-model="settings.SignWithOutContribution" :value="false" />
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <!-- modal-radio-block -->
                    </div>
                    <!-- modal-radio -->

                </div>
                <!-- gt-md-modal-content -->

                <div class="gt-md-modal-footer text-center">
                    <a href="javascript:void(0);" class="theme-btn-lite js-btn-step" @click="saveData">Save</a>
                    <div class="w-100" v-if="collectionSetupType=='showDelete'">
                        <hr class="w-100 mt-4 mb-4">
                        <a href="javascript:void(0);" class="theme-btn-delete" @click="confirmGCModal">Delete Collection/Card</a>
                    </div>
                    <p v-if="errorMessage" style="color:red;padding-top:5px;text-align:left;">{{errorMessage}}</p>
                </div>
                <!-- gt-md-modal-footer -->
            </div>
        </div>
    </div>

    <div class="modal fade gt-md-modal" id="confirmDeleteGC" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" style="z-index:9999999 !important">
        <div class="modal-dialog mt-4">
            <div class="modal-content">
                <div class="gt-md-modal-header">
                    <h2>Please confirm</h2>
                    <div class="gt-modal-close" data-dismiss="modal">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" width="14" height="14">
                                <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 13 1 L 7 7 L 13 13" />
                                <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 1 13 L 7 7 L 1 1" />
                            </svg>
                    </div>
                </div>
                <!-- gt-md-modal-header -->
                <div class="gt-md-modal-content text-center">
                    <div class="mb-4 mt-2">
                        <p class="position-relative d-inline-block">
                            <span id="error-text">
                                Are you sure, you want to delete group card?
                            </span>
                        </p>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <a href="javascript:void(0);" class="theme-btn-dark" data-dismiss="modal">Go Back</a>
                        </div>
                        <div class="col-6">
                            <a href="javascript:void(0);" class="theme-btn-lite" @click="deleteCard">Confirm</a>
                        </div>
                    </div>
                </div>
                <!-- gt-md-modal-content -->
            </div>
        </div>
    </div>

    <!-- Group card settings -->
</template>
<!--template html-->
<!--script -->
<script>

    export default {
        name: '',
        components: {
        },
        props: {
            collection: String,
              collectionSetupType: String,
        },
        data: function () {
            return {
                settings: null,
                errorMessage: "",
                displayLoader:false
            }
        },
        mounted: function () {
            this.getModelData();
        },
        methods: {
            confirmGCModal() {
                $('#confirmDeleteGC').modal();

            },
            getModelData() {
                fetch('/api/collectionservices/groupcardsettings?collection=' + this.collection)
                    .then((res) => res.json())
                    .then((data) => {
                        this.settings = data.Setting
                    })
                    .catch(err => console.log(err.message))
            },
            addPrintOption() {
                if (this.settings.Orders.length === 0) {
                    $("#gc-setting-modal").modal("hide")
                    $("#groupcard-print-modal").modal()
                }
            },
            deleteCard() {
                this.settings.DeleteCard = true
                this.saveData()
            },
            saveData() {
                this.displayLoader = true;
                this.errorMessage = ""
                //creating sending object
                let messageObj = {
                    Collection: this.collection,
                    DeleteCard: this.settings.DeleteCard,
                    SignWithOutContribution: this.settings.SignWithOutContribution,
                    PrintOption: this.settings.PrintOption
                }
                //create save request
                const requestOptions = {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(messageObj)
                };
                fetch('/api/collectionservices/savegroupcardsettings', requestOptions)
                    .then((res) => res.json())
                    .then((data) => {
                        if (data.StatusCode === 1) {
                            location.reload()
                        } else {
                            this.errorMessage = data.Message
                            this.displayLoader = false;
                        }
                    })
                    .catch(err => console.log(err.message))
            }
        },
        computed: {
            printOptionValue() {
                return this.settings.PrintOption
            }
        }
    }
</script>
<!--script -->
<!--Add "scoped" attribute to limit CSS to this component only-->
<style scoped>
</style>
